import DataPointPayment from "../../../components/units/DataPoint/Payment/DataPointPayment";

export default function DataPointPaymentPage() {
  return <DataPointPayment />;
}
